export default __webpack_public_path__ + "static/media/tk.a92e2152.svg";